import unitless from '@emotion/unitless';
import { StylisDeclarationElement, StylisElement, StylisPlugin } from 'stylis';
import { devWarning } from '@tanium/coreui-utils';
import { convertObjectPropertyToCssNotation } from './convertObjectPropertyToCssNotation';

const unitlessProperties = new Set(Object.keys(unitless).map(convertObjectPropertyToCssNotation));
const isUnitlessValue = (value: string) => !Number.isNaN(Number(value));

const isDeclaration = (element: StylisElement): element is StylisDeclarationElement =>
  element.type === 'decl';

const getNearestRule = (element: StylisElement): StylisElement | null => {
  if (element.type === 'rule') return element;

  return element.parent && getNearestRule(element.parent);
};

export const convertInvalidUnitlessValuesToPixels: StylisPlugin = (element) => {
  if (isDeclaration(element)) {
    const { children: value, props: prop } = element;
    if (
      value !== '0' &&
      isUnitlessValue(value) &&
      !unitlessProperties.has(prop) &&
      !prop.startsWith('--')
    ) {
      devWarning(false, () => {
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion -- declarations always have a rule ancestor.
        const rule = getNearestRule(element)!;
        return [
          'Invalid unitless css value',
          `\`${prop}: ${value}\``,
          `in the generated rule \`${rule.value}\`.`,
          'Did you mean to add `px`?',
        ].join(' ');
      });

      // eslint-disable-next-line no-param-reassign -- This is the API for stylis middleware
      element.return = (element.return || `${prop}:${value};`).replace(value, `${value}px`);
    }
  }
};
